import jwt from 'jsonwebtoken'

function decode (token: string) {
  return jwt.decode(token)
}

export default decode
